import { SxProps, Theme } from "@mui/material/styles";
import Colors from "../../../theme/Colours";

const EditCreditNoteModalStyles: Record<string, SxProps<Theme>> = {
  modalBox: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  },
  title: {
    mb: 2,
  },
  label: {
    mb: 1,
    mt: 2,
  },
  actions: {
    mt: 3,
  },
  confirmButtonStyle: {
    backgroundColor: Colors.primaryButtonOrange,
    color: Colors.background2,
    "&:hover": {
      backgroundColor: Colors.primaryButtonOrangeHover,
    },
  },
  cancelButtonStyle: {
    border: `1px solid ${Colors.primaryButtonOrange}`,
    color: Colors.primaryButtonOrange,
    backgroundColor: Colors.background2,
    "&:hover": {
      backgroundColor: Colors.primaryButtonOrange,
      color: Colors.background2,
    },
  },
};

export default EditCreditNoteModalStyles;
